<template>
  <Divider v-if="productVideo"></Divider>
  <h2 class="text--center mt-lg" ref="reviewSectionHeader" v-if="productVideo">
    How the product actually look like
  </h2>
  <div class="product-video" v-if="productVideo" v-html="productVideo"></div>
</template>
<script lang="ts" setup>
import useProductStore from '@/store/product'
import { computed } from '@vue/reactivity'
import Divider from '@/components/Divider.vue'

const productStore = useProductStore()
const productVideo = computed(
  () => productStore.productDescription?.video || ''
)
</script>

<style lang="scss">
.product-video {
  position: relative;
  padding-bottom: 56.25%; /* 16:9 */
  height: 0;
  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
